import { useEffect, useState } from 'react';
import { from, is, type SlotReference } from '@the-real-insight/tri-model';
import { userAPI } from '../UserAPI';
import { knownEntityType } from '../entities/entityTypes';

/** Die Felder, an denen ein Mensch eine Entität erkennt — zum Suchen und zum Beschriften. */
export const LABEL_FIELDS = ['name', 'companyName', 'institutionName', 'title', 'lastName', 'fileReference', 'fileOrPlanNumber', 'contractNumber', 'flstkennz', 'street'];

export const describeRecord = (record: any): string => {
    for (const name of LABEL_FIELDS) {
        const value = record?.[name];
        if (typeof value === 'string' && value.trim()) return name === 'lastName' && record.firstName ? `${record.firstName} ${value}` : value;
    }
    return String(record?._id ?? '');
};

/**
 * Wie ein Mensch die Entität hinter einem Bezug erkennt — einmal nachgeschlagen. Ohne Treffer bleibt es
 * bei `undefined`, und wer anzeigt, zeigt Art und Ende der Kennung.
 */
export const useReferenceLabel = (reference: SlotReference | null | undefined): string | undefined => {
    const [label, setLabel] = useState<string | undefined>(undefined);
    const id = reference?._id ? String(reference._id) : null;
    const type = reference?.type ?? null;
    useEffect(() => {
        setLabel(undefined);
        const known = type ? (knownEntityType(type) as any) : null;
        if (!id || !known) return;
        let cancelled = false;
        userAPI
            .query(from(known.type).where(is('_id').equal(id)), 0, 1)
            .then((rows: any[]) => {
                const found = rows?.[0] ? describeRecord(rows[0]) : undefined;
                if (!cancelled && found && found !== id) setLabel(found);
            })
            .catch(() => undefined);
        return () => {
            cancelled = true;
        };
    }, [id, type]);
    return label;
};

/** Ein Bezug als Text: die Bezeichnung, solange sie fehlt, was schon dasteht. */
export function ReferenceText({ reference, fallback }: { reference: SlotReference; fallback: string }) {
    const label = useReferenceLabel(reference) ?? fallback;
    return <span title={label}>{label}</span>;
}
